import { render, staticRenderFns } from "./Estanque_Aceite.vue?vue&type=template&id=3a18799f&"
import script from "./Estanque_Aceite.vue?vue&type=script&lang=js&"
export * from "./Estanque_Aceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports